module.exports = __webpack_public_path__ + "static/media/Flaticon.5be3e43c.woff";